import { Button, List, Tag } from "antd";
import styled from "styled-components";

export const Item = styled(List.Item)`
justify-content: center;
cursor: default;
&&:hover {
    background-color: #F8F8FC;
    cursor: pointer;
}
`;

export const StyledTag = styled(Tag)`
margin-bottom: 10px;
`;

export const ReturnButton = styled(Button)`
margin-bottom: 1rem;
margin-top: -40px;
`;
